// Every build of this app is one of a small set of "targets" — the live
// website, the itch.io standalone build, the tvain-share embed, the
// Electron desktop app (and, in future, embeds like a Godot plugin). This
// is the single place that defines what differs between them: where the
// backend lives, and which UI is shown.
//
// Pick a target at build time with `vue-cli-service build --mode <target>`
// (see the matching .env.<target> file, which just sets VUE_APP_TARGET).
// With no VUE_APP_TARGET set, "web" is the default.

const TARGETS = {
  // The live website (create.tvain-b.ink) and its local dev server.
  // "/api" is same-origin: proxied to the live backend in dev (see
  // vue.config.js devServer.proxy) and by the production reverse proxy.
  web: {
    apiUrl: "/api",
    standalone: false,
    shareMode: false,
    features: {
      autoLocalAccount: false,
    },
  },

  // Static, backend-less build (itch.io). All data lives in indexedDB.
  standalone: {
    apiUrl: "",
    standalone: true,
    shareMode: false,
    features: {
      autoLocalAccount: false,
    },
  },

  // Embedded inside the tvain-share site. Talks to tvain-share's own API,
  // relative to wherever it's hosted.
  share: {
    apiUrl: "",
    standalone: false,
    shareMode: true,
    features: {
      autoLocalAccount: false,
    },
  },

  // Electron desktop app (Windows/macOS/Linux). Talks to the Express
  // server embedded in the same process (see src/server.js), and silently
  // provisions the single local account instead of showing sign-up.
  electron: {
    apiUrl: "http://localhost:3030",
    standalone: false,
    shareMode: false,
    features: {
      autoLocalAccount: true,
    },
  },
};

const name = process.env.VUE_APP_TARGET || "web";
const target = TARGETS[name];

if (!target) {
  throw new Error(
    `Unknown VUE_APP_TARGET "${name}". Expected one of: ${Object.keys(TARGETS).join(", ")}`
  );
}

export default { name, ...target };
